import React from 'react';
import styles from './PublicMarketingLayout.module.css';

const PublicSiteSkipLink: React.FC = () => (
  <a href="#main-content" className={styles.skipToMain}>
    Skip to main content
  </a>
);

export default PublicSiteSkipLink;
